function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
var LocaleManager = /*#__PURE__*/function () {
  function LocaleManager(config) {
    _classCallCheck(this, LocaleManager);
    this._locales = {};
    for (var i in config) {
      this._locales[i] = config[i];
    }
  }
  _createClass(LocaleManager, [{
    key: "addLocale",
    value: function addLocale(name, locale) {
      this._locales[name] = locale;
    }
  }, {
    key: "getLocale",
    value: function getLocale(name) {
      return this._locales[name];
    }
  }]);
  return LocaleManager;
}();
export { LocaleManager as default };